<div>
  <mat-card>
    <mat-card-header class="titreFrm">
      <mat-card-title>{{ typeCollText }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
      <div *ngIf="exist; else attente"></div>
      <ng-template #attente>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
      <!-------------------- bouton -->
      <div class="btn">
        <!-- <div class="button-row">
            <button *ngIf="!disabled" [disabled]="!exist || disabled" (click)="retourListes()" mat-raised-button class="colorGreen"> <mat-icon>format_list_bulleted</mat-icon>Liste des {{typeCollText.toLowerCase()}}s</button>
          </div> -->
        <div
          *ngIf="
            showEditerContrat &&
            (perso_Type == '0' || perso_Type == '2') &&
            typeTrs != '1'
          "
          class="button-row"
        >
          <button
            *ngIf="!disabled"
            [disabled]="!exist || disabled"
            (click)="telechargerContart()"
            mat-raised-button
            class="colorGreen"
          >
            <mat-icon>edit</mat-icon>&Eacute;diter le contrat
          </button>
        </div>
        <div class="button-row">
          <button
            *ngIf="!disabled && index < 2"
            [disabled]="!exist || disabled"
            (click)="enregister()"
            mat-raised-button
            class="colorGreen"
          >
            <mat-icon>save</mat-icon>Enregistrer
          </button>
        </div>
      </div>
      <mat-tab-group
        #tabGroupe
        [(selectedIndex)]="index"
        (selectedTabChange)="tabChanged($event)"
        (focusChange)="setOldIndex()"
      >
        <!-------------------- Informations ------------>
        <mat-tab [label]="informations">
          <form class="example-form" #formInformation="ngForm">
            <input
              type="submit"
              style="display: none"
              id="btnFormInformation"
            />
            <br />
            <div class="displayFlex">
              <mat-card [ngClass]="classCardInformation">
                <!-- <mat-card-header class="heightTitre">
                    <mat-card-title><h3>Enregistrer {{typeCollText}}</h3></mat-card-title>
                  </mat-card-header> -->
                <mat-card-content>
                  <div class="btn2">
                    <div style="width: calc(50% - 10px); margin-right: 10px">
                      <span>Civilité</span><br />
                      <mat-radio-group
                        (change)="sexeChange($event)"
                        name="PersoCivilite"
                        [(ngModel)]="data.Perso_Civilite"
                      >
                        <mat-radio-button
                          style="margin-right: 10px"
                          [disabled]="disabled"
                          value="Monsieur"
                          >Monsieur </mat-radio-button
                        ><br />
                        <mat-radio-button [disabled]="disabled" value="Madame"
                          >Madame</mat-radio-button
                        >
                      </mat-radio-group>
                      <mat-form-field
                        appearance="outline"
                        class="aaa full-width"
                      >
                        <mat-label>Nom</mat-label>
                        <input
                          required
                          matInput
                          [disabled]="disabled"
                          name="Perso_Nom"
                          #Perso_Nom="ngModel"
                          (input)="
                            removeNumberFromText(data.Perso_Nom, 'Perso_Nom')
                          "
                          [(ngModel)]="data.Perso_Nom"
                          placeholder="Nom"
                        />
                      </mat-form-field>
                      <mat-form-field
                        appearance="outline"
                        class="aaa full-width"
                      >
                        <mat-label>Pr&eacute;nom</mat-label>
                        <input
                          matInput
                          [disabled]="disabled"
                          name="Perso_Prenom"
                          #Perso_Prenom="ngModel"
                          (input)="
                            removeNumberFromText(
                              data.Perso_Prenom,
                              'Perso_Prenom'
                            )
                          "
                          [(ngModel)]="data.Perso_Prenom"
                          placeholder="Pr&eacute;nom"
                        />
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Date naissance</mat-label>
                        <input
                          matInput
                          [disabled]="disabled"
                          name="Perso_DateNaissance"
                          #Perso_DateNaissance="ngModel"
                          [(ngModel)]="data.Perso_DateNaissance"
                          (dateChange)="dateCollChange()"
                          [matDatepicker]="DateNaissance"
                          placeholder="Date naissance"
                        />
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="DateNaissance"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #DateNaissance></mat-datepicker>
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Lieu naissance</mat-label>
                        <input
                          matInput
                          [disabled]="disabled"
                          name="Perso_Lieu_NE"
                          #Perso_Lieu_NE="ngModel"
                          (input)="
                            removeNumberFromText(
                              data.Perso_Lieu_NE,
                              'Perso_Lieu_NE'
                            )
                          "
                          [(ngModel)]="data.Perso_Lieu_NE"
                          placeholder="Lieu naissance"
                        />
                      </mat-form-field>
                      <mat-form-field
                        appearance="outline"
                        *ngIf="perso_Type == '0'"
                        style="width: 200px; margin-right: 10px"
                        class=""
                      >
                        <mat-label>Type fonction</mat-label>
                        <mat-select
                          [disabled]="disabled"
                          name="Perso_Fonction"
                          #Perso_Fonction="ngModel"
                          [(ngModel)]="data.Perso_Fonction"
                          placeholder="Type fonction"
                        >
                          <mat-option
                            *ngFor="let fn of listeTypeFontion"
                            [value]="fn.DiverSys_Index"
                          >
                            {{ fn.DiverSys_Titre }}</mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field
                        appearance="outline"
                        *ngIf="perso_Type == '0' || perso_Type == '1'"
                        style="width: 200px"
                        class=""
                      >
                        <mat-label>{{
                          "Type " + typeCollText.toLowerCase()
                        }}</mat-label>
                        <mat-select
                          [disabled]="disabled"
                          name="Perso_TypePerso"
                          #Perso_TypePerso="ngModel"
                          [(ngModel)]="data.Perso_TypePerso"
                          [placeholder]="'Type ' + typeCollText.toLowerCase()"
                          (selectionChange)="onTypePersoChange($event.value)"
                        >
                          <mat-option
                            *ngFor="let type_Coll of listeTypePerso"
                            [value]="type_Coll.DiverSys_Index"
                          >
                            {{ type_Coll.DiverSys_Titre }}</mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div style="width: 50%">
                      <img (click)="selectImage()" [src]="avatarSrc" />
                      <input
                        type="file"
                        style="display: none"
                        id="imageFile"
                        (change)="onChangeImagefile($event)"
                      />
                      <div
                        class="button-row"
                        style="text-align: center; margin-top: 5px"
                      >
                        <button
                          *ngIf="!disabled"
                          [disabled]="!exist || disabled"
                          (click)="selectImage()"
                          mat-raised-button
                          class="colorGreen"
                        >
                          Choisir une photo
                        </button>
                      </div>
                      <app-recherche
                        [disabled]="disabled"
                        *ngIf="perso_Type == '2'"
                        [api]="generalService.api"
                        ngModel
                        [(ngModel)]="steApprenant"
                        [numColonneToShow]="1"
                        [numColonneToReturn]="0"
                        [style]="{ width: '180px', 'margin-top': '5px' }"
                        (ChampEnter)="blurSteApprenant($event)"
                        recherche="TierType"
                        [param]="'1'"
                        name="name_1"
                        placeholder="Sté de l'apprenant"
                      >
                      </app-recherche>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
              <!-------------------- Coordonner ------------>
              <mat-card [ngClass]="classCardInformation">
                <mat-card-header class="heightTitre">
                  <mat-card-title>Coordonnées</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <mat-form-field
                    appearance="outline"
                    *ngIf="show && data.Perso_NumSecu != undefined"
                    class="width50"
                  >
                    <mat-label>Num&eacute;ro s&eacute;cu</mat-label>
                    <span id="PrefixSexe" matPrefix>1</span>
                    <input
                      matInput
                      [disabled]="disabled"
                      (input)="removeTextFromNumber()"
                      name="Perso_NumSecu"
                      #Perso_NumSecu="ngModel"
                      [(ngModel)]="data.Perso_NumSecu"
                      placeholder="Num&eacute;ro s&eacute;cu"
                      maxlength="14"
                      minlength="14"
                    />
                    <mat-hint align="end"
                      >{{ data.Perso_NumSecu.length + 1 }} / 15</mat-hint
                    >
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Mail pro</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Perso_MailPro"
                      pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                      [(ngModel)]="data.Perso_MailPro"
                      placeholder="Mail pro"
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Mail perso</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Perso_mail"
                      pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                      [(ngModel)]="data.Perso_mail"
                      placeholder="Mail perso"
                    />
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    class="width50 marginRight10"
                  >
                    <mat-label>Mobile</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      type="number"
                      name="Perso_Mobile"
                      #Perso_Mobile="ngModel"
                      [(ngModel)]="data.Perso_Mobile"
                      placeholder="Mobile"
                    />
                    <mat-hint align="end">
                      {{
                        data.Perso_Mobile && data.Perso_Mobile != null
                          ? data.Perso_Mobile.toString().length
                          : "0"
                      }}
                      / 9</mat-hint
                    >
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="width50">
                    <mat-label>T&eacute;l&eacute;phone fixe</mat-label>
                    <input
                      matInput
                      type="number"
                      [disabled]="disabled"
                      name="Perso_Tel"
                      [(ngModel)]="data.Perso_Tel"
                      placeholder="T&eacute;l&eacute;phone fixe"
                    />
                    <mat-hint align="end">
                      {{
                        data.Perso_Tel && data.Perso_Tel != null
                          ? data.Perso_Tel.toString().length
                          : "0"
                      }}
                      / 9
                    </mat-hint>
                  </mat-form-field>
                  <h4 *ngIf="showCompetenceColl && perso_Type == '1'">
                    Liste des compétences
                  </h4>
                  <mat-selection-list
                    *ngIf="showCompetenceColl && perso_Type == '1'"
                    [disabled]="disabled"
                    name="Perso_Competence"
                    #listeCompetences
                    (selectionChange)="
                      onSelectionCompetence(
                        listeCompetences.selectedOptions.selected
                      )
                    "
                    style="height: 100px; overflow-y: scroll"
                  >
                    <mat-list-option
                      [ngStyle]="{ height: '35px' }"
                      [(ngModel)]="competence.DiverSys_Index"
                      *ngFor="let competence of dataCompetence"
                      [selected]="competence.selected"
                    >
                      {{ competence.DiverSys_Titre }}
                    </mat-list-option>
                  </mat-selection-list>
                </mat-card-content>
              </mat-card>
              <!-------------------- Adresse ------------>

              <mat-card [ngClass]="classCardInformation">
                <mat-card-header class="heightTitre">
                  <mat-card-title>Adresse</mat-card-title>
                </mat-card-header>
                <mat-card-content class="adresse">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Adresse</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Perso_Adresse"
                      [(ngModel)]="data.Perso_Adresse"
                      placeholder="Adresse"
                      ngx-google-places-autocomplete
                      #placesRef="ngx-places"
                      (onAddressChange)="handleAddressChange($event, '')"
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Rue</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Perso_Adresse2"
                      #Perso_Adresse2="ngModel"
                      [(ngModel)]="data.Perso_Adresse2"
                      placeholder="Rue"
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    *ngIf="perso_Type == '0'"
                    class="full-width"
                  >
                    <mat-label>Compl&eacute;ment</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Perso_Complement"
                      #Perso_Complement="ngModel"
                      [(ngModel)]="data.Perso_Complement"
                      placeholder="Compl&eacute;ment"
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="width50 marginRight10"
                  >
                    <mat-label>Code postal</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Perso_Poste"
                      #Perso_Poste="ngModel"
                      [(ngModel)]="data.Perso_Poste"
                      placeholder="Code postal"
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="width50">
                    <mat-label>Ville</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Perso_Ville"
                      #Perso_Ville="ngModel"
                      [(ngModel)]="data.Perso_Ville"
                      placeholder="Ville"
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="width50 marginRight10"
                  >
                    <mat-label>Pays</mat-label>
                    <input
                      [disabled]="disabled"
                      matInput
                      [matAutocomplete]="auto"
                      name="Perso_Pays"
                      #Perso_Pays="ngModel"
                      [(ngModel)]="data.Perso_Pays"
                      placeholder="Pays"
                      (input)="onPaysChange($event)"
                    />
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option
                        [(ngModel)]="ps.libelle"
                        *ngFor="let ps of pays"
                      >
                        {{ ps.libelle }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="width50">
                    <mat-label>Nationalite</mat-label>
                    <input
                      [disabled]="disabled"
                      matInput
                      [matAutocomplete]="auto3"
                      #Perso_Nationalite="ngModel"
                      name="Perso_Nationalite"
                      [(ngModel)]="data.Perso_Nationalite"
                      placeholder="Nationalite"
                      (input)="onNationaliteChange($event)"
                    />
                    <mat-autocomplete #auto3="matAutocomplete">
                      <mat-option
                        [(ngModel)]="nat.nationalite"
                        *ngFor="let nat of nationalite"
                      >
                        {{ nat.nationalite }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="width50">
                    <mat-label>Date de recrutement</mat-label>
                    <input
                      matInput
                      [matDatepicker]="pickerDateEmb"
                      id="naissance"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pickerDateEmb"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pickerDateEmb></mat-datepicker>
                  </mat-form-field>

                  <!-- <mat-form-field     appearance="outline"  *ngIf="perso_Type != '2' && perso_Type != '10' && perso_Type != '11'" class="width50  ">
                      <input matInput [disabled]="disabled" name="Perso_Departement" #Perso_Departement="ngModel"
                        [(ngModel)]="data.Perso_Departement" placeholder="D&eacute;partement" >
                    </mat-form-field> -->
                </mat-card-content>
              </mat-card>
            </div>
            <!-------------------- Responsable légal ------------>

            <div *ngIf="perso_Type == '2' && !apprenantNotMineur">
              <h4 style="margin-left: 20px; font-weight: bold">
                Responsable légal
              </h4>
              <div class="displayFlex">
                <mat-card class="cardInformationApprenant">
                  <mat-card-content>
                    <span>Civilité</span><br />
                    <mat-radio-group
                      name="PersoRL_Civilite"
                      [(ngModel)]="data.PersoRL_Civilite"
                    >
                      <mat-radio-button
                        style="margin-right: 10px"
                        [disabled]="disabled"
                        value="Monsieur"
                        >Monsieur
                      </mat-radio-button>
                      <mat-radio-button [disabled]="disabled" value="Madame"
                        >Madame</mat-radio-button
                      > </mat-radio-group
                    ><br />
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Nom</mat-label>
                      <input
                        matInput
                        [disabled]="disabled"
                        name="PersoRL_Nom"
                        #PersoRL_Nom="ngModel"
                        (input)="
                          removeNumberFromText(data.PersoRL_Nom, 'PersoRL_Nom')
                        "
                        [(ngModel)]="data.PersoRL_Nom"
                        placeholder="Nom"
                        [required]="!apprenantNotMineur"
                      />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Pr&eacute;nom</mat-label>
                      <input
                        matInput
                        [disabled]="disabled"
                        name="PersoRL_Prenom"
                        #PersoRL_Prenom="ngModel"
                        (input)="
                          removeNumberFromText(
                            data.PersoRL_Prenom,
                            'PersoRL_Prenom'
                          )
                        "
                        [(ngModel)]="data.PersoRL_Prenom"
                        placeholder="Pr&eacute;nom"
                        [required]="!apprenantNotMineur"
                      />
                    </mat-form-field>
                  </mat-card-content>
                </mat-card>
                <!-------------------- Coordonner Responsable légal ------------>
                <mat-card class="cardInformationApprenant">
                  <mat-card-header class="heightTitre">
                    <mat-card-title>Coordonnées</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Mail pro</mat-label>
                      <input
                        matInput
                        [disabled]="disabled"
                        name="PersoRL_MailPro"
                        pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                        [(ngModel)]="data.PersoRL_MailPro"
                        placeholder="Mail pro"
                        [required]="!apprenantNotMineur"
                      />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Mail perso</mat-label>
                      <input
                        matInput
                        [disabled]="disabled"
                        name="PersoRL_MailPerso"
                        pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                        [(ngModel)]="data.PersoRL_MailPerso"
                        placeholder="Mail perso"
                        [required]="!apprenantNotMineur"
                      />
                    </mat-form-field>

                    <mat-form-field
                      appearance="outline"
                      class="width50 marginRight10"
                    >
                      <mat-label>Mobile</mat-label>
                      <input
                        matInput
                        [disabled]="disabled"
                        type="number"
                        name="PersoRL_Mobile"
                        #Perso_Mobile="ngModel"
                        [(ngModel)]="data.PersoRL_Mobile"
                        placeholder="Mobile"
                        [required]="!apprenantNotMineur"
                      />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="width50">
                      <mat-label>T&eacute;l&eacute;phone fixe</mat-label>
                      <input
                        matInput
                        type="number"
                        [disabled]="disabled"
                        name="PersoRL_Fixe"
                        [(ngModel)]="data.PersoRL_Fixe"
                        placeholder="T&eacute;l&eacute;phone fixe"
                        [required]="!apprenantNotMineur"
                      />
                    </mat-form-field>
                  </mat-card-content>
                </mat-card>
                <!-------------------- Adresse Responsable légal ------------>
                <mat-card class="cardInformationApprenant">
                  <mat-card-header class="heightTitre">
                    <mat-card-title>Adresse</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Adresse</mat-label>
                      <input
                        matInput
                        [disabled]="disabled"
                        name="PersoRL_Adresse"
                        [(ngModel)]="data.PersoRL_Adresse"
                        placeholder="Adresse"
                        ngx-google-places-autocomplete
                        #placesRef_Apprenant="ngx-places"
                        (onAddressChange)="
                          handleAddressChange($event, '_Apprenant')
                        "
                        [required]="!apprenantNotMineur"
                      />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Rue</mat-label>
                      <input
                        matInput
                        [disabled]="disabled"
                        name="PersoRL_Rue"
                        #PersoRL_Rue="ngModel"
                        [(ngModel)]="data.PersoRL_Rue"
                        placeholder="Rue"
                        [required]="!apprenantNotMineur"
                      />
                    </mat-form-field>

                    <mat-form-field
                      appearance="outline"
                      class="width50 marginRight10"
                    >
                      <mat-label>Code postal</mat-label>
                      <input
                        matInput
                        [disabled]="disabled"
                        name="PersoRL_CP"
                        #PersoRL_CP="ngModel"
                        [(ngModel)]="data.PersoRL_CP"
                        placeholder="Code postal"
                        [required]="!apprenantNotMineur"
                      />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="width50">
                      <mat-label>Ville</mat-label>
                      <input
                        matInput
                        [disabled]="disabled"
                        name="PersoRL_Ville"
                        #PersoRL_Ville="ngModel"
                        [(ngModel)]="data.PersoRL_Ville"
                        placeholder="Ville"
                        [required]="!apprenantNotMineur"
                      />
                    </mat-form-field>
                    <mat-form-field
                      appearance="outline"
                      class="width50 marginRight10"
                    >
                      <mat-label>Pays</mat-label>
                      <input
                        [disabled]="disabled"
                        matInput
                        [matAutocomplete]="auto"
                        name="PersoRL_Pays"
                        #PersoRL_Pays="ngModel"
                        [(ngModel)]="data.PersoRL_Pays"
                        placeholder="Pays"
                        [required]="!apprenantNotMineur"
                        (input)="onPaysChange($event)"
                      />
                      <mat-autocomplete #auto="matAutocomplete">
                        <mat-option
                          [(ngModel)]="ps.libelle"
                          *ngFor="let ps of pays"
                        >
                          {{ ps.libelle }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </form>
        </mat-tab>
        <!-- ---------------------Modalités de la formation -->
        <mat-tab
          *ngIf="perso_Type == '2'"
          [disabled]="disabledModaliteFormation"
          [label]="modaliterFormation"
        >
          <ng-template #frmModaliterFormation>
            <div *ngIf="exist; else attente2"></div>
            <ng-template #attente2>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </ng-template>
            <div style="overflow-y: auto; height: 100%">
              <form class="example-form" #formModaliteFormation="ngForm">
                <div>
                  <div class="btn2">
                    <h4>Cursus</h4>
                    <span>
                      <button
                        *ngIf="!disabled"
                        [disabled]="!exist || disabled"
                        (click)="
                          enregistrerModaliterFormation(formModaliteFormation)
                        "
                        mat-raised-button
                        class="button-row colorGreen"
                      >
                        <mat-icon>save</mat-icon>Enregistrer
                      </button>
                      <button
                        [disabled]="!exist || disabled"
                        (click)="fermerModaliterFormation()"
                        mat-raised-button
                        class="colorRed button-row"
                      >
                        <mat-icon>close</mat-icon>Fermer
                      </button>
                    </span>
                  </div>

                  <input
                    type="submit"
                    style="display: none"
                    id="btnModaliteFormation"
                  />
                  <!-- ---------------------Modalités -------- -->
                  <mat-card class="cardModalite">
                    <mat-card-header class="heightTitre">
                      <mat-card-title>Modalités</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                      <mat-radio-group
                        name="avtCursusApprenant_Nature"
                        [(ngModel)]="cursusApprenant.avtCursusApprenant_Nature"
                      >
                        <mat-radio-button
                          *ngFor="let nature of listeNature"
                          style="margin-right: 10px"
                          [disabled]="disabled"
                          [value]="nature.value"
                          >{{ nature.text }}</mat-radio-button
                        >
                      </mat-radio-group>
                      <mat-form-field
                        appearance="outline"
                        style="width: 100px"
                        class=""
                      >
                        <mat-label>Formation</mat-label>
                        <mat-select
                          name="avtCursus_Apprenant_Mododalite"
                          #avtCursus_Apprenant_Mododalite="ngModel"
                          [(ngModel)]="
                            cursusApprenant.avtCursusApprenant_Mododalite
                          "
                          placeholder="Formation"
                        >
                          <mat-option
                            *ngFor="let modaliter of listeModaliterApprenant"
                            [value]="modaliter.DiverSys_Index"
                          >
                            {{ modaliter.DiverSys_Titre }}</mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                      <!-- <br> -->
                      <mat-form-field
                        appearance="outline"
                        style="width: 160px"
                        class=""
                      >
                        <mat-label>Type apprenant</mat-label>
                        <mat-select
                          name="avtCursusApprenant_TypeApp"
                          #avtCursusApprenant_TypeApp="ngModel"
                          [(ngModel)]="
                            cursusApprenant.avtCursusApprenant_TypeApp
                          "
                          (selectionChange)="onTypePersoChange($event.value)"
                          placeholder="Type apprenant"
                          required
                        >
                          <mat-option
                            *ngFor="let type_Apprenant of listeTypePerso"
                            [value]="type_Apprenant.DiverSys_Index"
                          >
                            {{ type_Apprenant.DiverSys_Titre }}</mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field
                        appearance="outline"
                        style="width: 150px"
                        class=""
                      >
                        <mat-label>Type contrat</mat-label>
                        <mat-select
                          [disabled]="disabled"
                          name="avtCursusApprenantTypeContrat"
                          #avtCursusApprenant_TypeContrat="ngModel"
                          [(ngModel)]="
                            cursusApprenant.avtCursusApprenant_TypeContrat
                          "
                          placeholder=""
                        >
                          <mat-option
                            *ngFor="let type_Contrat of contrats"
                            [value]="type_Contrat.DiverSys_Index"
                          >
                            {{ type_Contrat.DiverSys_Titre }}</mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                      <!-- <br> -->
                      <mat-form-field
                        appearance="outline"
                        style="width: 200px"
                        class=""
                      >
                        <mat-label>Cursus</mat-label>
                        <mat-select
                          name="Cursus_Code"
                          #Cursus_Code="ngModel"
                          [(ngModel)]="cursusApprenant.Cursus_Code"
                          placeholder="Cursus"
                        >
                          <mat-option
                            *ngFor="let cursus of listeCursus"
                            [value]="cursus.Cursus_Code"
                          >
                            {{ cursus.Cursus_Titre }}</mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                      <!-- Dates Modalités de la formation -->
                      <mat-form-field
                        appearance="outline"
                        class="marginRight10 width-120px"
                      >
                        <mat-label>Date debut</mat-label>
                        <input
                          matInput
                          [disabled]="disabled"
                          name="avtCursusApprenant_Deb"
                          #avtCursusApprenant_Deb="ngModel"
                          [(ngModel)]="cursusApprenant.avtCursusApprenant_Deb"
                          [matDatepicker]="PersoDateDebutApprenant"
                          placeholder="Date debut"
                          (dateChange)="dateCursusApprenant_DebCollChange()"
                        />
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="PersoDateDebutApprenant"
                        ></mat-datepicker-toggle>
                        <mat-datepicker
                          #PersoDateDebutApprenant
                        ></mat-datepicker>
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="width-120px">
                        <mat-label>Date fin</mat-label>
                        <input
                          matInput
                          [disabled]="disabled"
                          name="avtCursusApprenant_Fin"
                          #avtCursusApprenant_Fin="ngModel"
                          [(ngModel)]="cursusApprenant.avtCursusApprenant_Fin"
                          [matDatepicker]="PersoDateFinApprenant"
                          placeholder="Date fin"
                        />
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="PersoDateFinApprenant"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #PersoDateFinApprenant></mat-datepicker>
                      </mat-form-field>
                    </mat-card-content>
                  </mat-card>
                  <div>
                    <!-- ----------diplome Modalités de la formation -->
                    <!-- <mat-card class="cardModaliteDiplome">
                        <mat-card-header class="heightTitre">
                          <mat-card-title>Diplome</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                          <mat-form-field     appearance="outline"  class=" full-width">
                            <input matInput [disabled]="disabled" name="Perso_Diplome" #Perso_Diplome="ngModel"
                              [(ngModel)]="cursusApprenant.Perso_Diplome" placeholder="Derniere diplome obtenu" required>
                          </mat-form-field>
                        </mat-card-content>
                      </mat-card> -->
                  </div>
                </div>
              </form>
              <div
                style="margin-top: 10px"
                *ngIf="
                  cursusApprenant.avtCursusApprenant_Id != undefined &&
                  cursusApprenant.avtCursusApprenant_Id != null &&
                  cursusApprenant.avtCursusApprenant_Id != ''
                "
              >
                <div class="btn2">
                  <h5>Liste financeurs</h5>
                  <span>
                    <button
                      *ngIf="!disabled"
                      [disabled]="!exist || disabled"
                      (click)="ajouterFinanceur()"
                      mat-raised-button
                      class="colorGreen button-row"
                    >
                      <mat-icon>add</mat-icon>Ajouter
                    </button>
                    <button
                      *ngIf="!disabled"
                      [disabled]="!exist || disabled"
                      (click)="ModifierFinanceur()"
                      mat-raised-button
                      class="colorGreen button-row"
                    >
                      <mat-icon>edite</mat-icon>Modifier
                    </button>
                    <button
                      *ngIf="!disabled"
                      [disabled]="!exist || disabled"
                      (click)="supprimerFinanceur()"
                      mat-raised-button
                      class="colorRed button-row"
                    >
                      <mat-icon>delete</mat-icon>Supprimer
                    </button>
                  </span>
                </div>
                <mat-card class="cardModalite">
                  <div class="btn2">
                    <div>
                      <app-recherche
                        [disabled]="disabled"
                        [api]="generalService.api"
                        [param]="'1'"
                        [numColonneToShow]="1"
                        [numColonneToReturn]="0"
                        [style]="{ width: '150px', 'margin-right': '5px' }"
                        (ChampEnter)="blurFinanceur($event)"
                        recherche="TierType"
                        name="newMachine2"
                        placeholder="Financeur"
                      ></app-recherche>
                      <mat-form-field appearance="outline" style="width: 70px">
                        <mat-label>Heure</mat-label>
                        <input
                          matInput
                          type="number"
                          name="avtCursusFinance_NbrHeure"
                          #avtCursusFinance_NbrHeure="ngModel"
                          [(ngModel)]="
                            avtCursusFinance.avtCursusFinance_NbrHeure
                          "
                          placeholder="Heure"
                        />
                      </mat-form-field>
                      <mat-form-field appearance="outline" style="width: 180px">
                        <mat-label>Mode de facturation</mat-label>
                        <mat-select
                          name="avtCursusFinance_ModeFacturation"
                          #avtCursusFinance_ModeFacturation="ngModel"
                          [(ngModel)]="
                            avtCursusFinance.avtCursusFinance_ModeFacturation
                          "
                          placeholder="Mode de facturation"
                        >
                          <mat-option
                            *ngFor="let ModeFacturation of listeModeFacturation"
                            [value]="ModeFacturation.DiverSys_Index"
                          >
                            {{ ModeFacturation.DiverSys_Titre }}</mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="outline" style="width: 150px">
                        <mat-label>Délai reglement</mat-label>
                        <mat-select
                          name="avtCursusFinance_DelaiReglement"
                          #avtCursusFinance_DelaiReglement="ngModel"
                          [(ngModel)]="
                            avtCursusFinance.avtCursusFinance_DelaiReglement
                          "
                          placeholder="Délai reglement"
                        >
                          <mat-option
                            *ngFor="let DelaiReglement of listeDelaiReglement"
                            [value]="DelaiReglement.DiverSys_Index"
                          >
                            {{ DelaiReglement.DiverSys_Titre }}</mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="outline" style="width: 170px">
                        <mat-label>Mode de paiement</mat-label>
                        <mat-select
                          name="avtCursusFinance_ModePaiement"
                          #avtCursusFinance_ModePaiement="ngModel"
                          [(ngModel)]="
                            avtCursusFinance.avtCursusFinance_ModePaiement
                          "
                          placeholder="Mode de paiement"
                        >
                          <mat-option
                            *ngFor="let ModePaiement of listeModePaiement"
                            [value]="ModePaiement.DiverSys_Index"
                          >
                            {{ ModePaiement.DiverSys_Titre }}</mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="outline" style="width: 70px">
                        <mat-label>TVA</mat-label>
                        <mat-select
                          name="avtCursusFinance_Tva"
                          #avtCursusFinance_Tva="ngModel"
                          [(ngModel)]="avtCursusFinance.avtCursusFinance_Tva"
                          placeholder="TVA"
                        >
                          <mat-option
                            *ngFor="let tva of listeTva"
                            [value]="tva.DiverSys_Index"
                          >
                            {{ tva.DiverSys_Titre }}</mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <app-avt-listes
                    (Champ_Enter)="onChangeComposonRecherche($event)"
                    #listeFinanceurComponen
                    [showFilter]="false"
                    [heightTable]="'200'"
                    [dataSourceBrut]="datasourceFinanceur"
                    [displayedColumnsBrut]="columnsFinanceur"
                  ></app-avt-listes>
                </mat-card>
              </div>
            </div>
          </ng-template>
          <br />
          <div *ngIf="showListeModaliterFormation">
            <app-avt-listes
              #listeModaliterFormationComponen
              [showFilter]="false"
              [heightTable]="'400'"
              [dataSourceBrut]="datasourceModaliterFormation"
              [displayedColumnsBrut]="columnsModaliterFormation"
              [listBtn]="listBtnModaliterFormation"
              (btnTable)="actionBtnModaliter($event)"
            ></app-avt-listes>
          </div>
        </mat-tab>
        <!-- ----------------Situation professionnelle ------------------------------>
        <mat-tab
          *ngIf="perso_Type == '0'"
          [disabled]="disabledSituationProfessionnelle"
          [label]="situationPro"
        >
          <form class="example-form" #formSituationProfessionnelle="ngForm">
            <input
              type="submit"
              style="display: none"
              id="btnSituationProfessionnelle"
            />
            <br />
            <div class="displayFlex">
              <mat-card class="cardSituationPro">
                <mat-card-content>
                  <mat-selection-list
                    *ngIf="showCompetenceColl && perso_Type == '0'"
                    [disabled]="disabled"
                    name="Perso_Competence"
                    #listeCompetences
                    (selectionChange)="
                      onSelectionCompetence(
                        listeCompetences.selectedOptions.selected
                      )
                    "
                    style="height: 140px; overflow-y: scroll"
                  >
                    <mat-list-option
                      [ngStyle]="{ height: '35px' }"
                      *ngFor="let competence of dataCompetence"
                      [(ngModel)]="competence.DiverSys_Index"
                      [selected]="competence.selected"
                    >
                      {{ competence.DiverSys_Titre }}
                    </mat-list-option>
                  </mat-selection-list>
                  <div>
                    <mat-form-field
                      appearance="outline"
                      class="width50 marginRight10"
                    >
                      <mat-label>Fonction</mat-label>
                      <input
                        matInput
                        [disabled]="disabled"
                        name="Perso_Emploi"
                        #Perso_Emploi="ngModel"
                        (input)="
                          removeNumberFromText(
                            data.Perso_Emploi,
                            'Perso_Emploi'
                          )
                        "
                        [(ngModel)]="data.Perso_Emploi"
                        placeholder="Fonction"
                      />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Domaine</mat-label>
                      <textarea
                        matInput
                        [disabled]="disabled"
                        name="Perso_Domaine"
                        #Perso_Domaine="ngModel"
                        [(ngModel)]="data.Perso_Domaine"
                        placeholder="Domaine"
                      ></textarea>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Type contrat</mat-label>
                      <mat-select
                        [disabled]="disabled"
                        name="Perso_ContratType"
                        [(ngModel)]="data.Perso_ContratType"
                        placeholder="Type contrat"
                        (selectionChange)="onContratChange()"
                      >
                        <mat-option
                          *ngFor="let contrat of contrats"
                          [value]="contrat.DiverSys_Index"
                        >
                          {{ contrat.DiverSys_Titre }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field
                      appearance="outline"
                      class="width-160px marginRight10"
                    >
                      <mat-label>Temps</mat-label>
                      <mat-select
                        [disabled]="disabled"
                        name="Perso_Temps"
                        [(ngModel)]="data.Perso_Temps"
                        placeholder="Temps"
                      >
                        <mat-option
                          *ngFor="let temp of temps"
                          [value]="temp.DiverSys_Index"
                          >{{ temp.DiverSys_Titre }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <!-- <mat-form-field     appearance="outline"  class=" width-80px marginRight10">
                      <mat-label>Nbr.Km/an</mat-label>
                        <input matInput [disabled]="disabled" name="Perso_TauxKm" type="number"
                          [(ngModel)]="data.Perso_TauxKm" placeholder="Taux Km" >
                      </mat-form-field> -->
                    <mat-form-field appearance="outline" class="width-80px">
                      <mat-label>Nbr.Chevaux</mat-label>
                      <input
                        matInput
                        [disabled]="disabled"
                        name="Perso_VoitureNBChaveaux"
                        type="number"
                        [(ngModel)]="data.Perso_VoitureNBChaveaux"
                        placeholder="Taux Km"
                      />
                    </mat-form-field>
                    <br />
                    <mat-form-field
                      appearance="outline"
                      class="width50 marginRight10"
                    >
                      <mat-label>Type rémunération</mat-label>
                      <mat-select
                        [disabled]="disabled"
                        name="Perso_Regime"
                        [(ngModel)]="data.Perso_Regime"
                        placeholder="Type rémunération"
                      >
                        <mat-option
                          *ngFor="let remuneration of remunerations"
                          [value]="remuneration.DiverSys_Index"
                        >
                          {{ remuneration.DiverSys_Titre }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="width33">
                      <mat-label>Rémunération</mat-label>
                      <input
                        matInput
                        [disabled]="disabled"
                        name="Perso_Salaire"
                        type="number"
                        [(ngModel)]="data.Perso_Salaire"
                        placeholder="Rémunération"
                      />
                    </mat-form-field>

                    <!-- <mat-form-field     appearance="outline"  class=" example-full-width">
                      <input matInput [disabled]="disabled" name="Perso_Salaire" [(ngModel)]="data.Perso_Salaire"
                        placeholder="Salaire horaire brut" >
                    </mat-form-field> -->
                  </div>
                </mat-card-content>
              </mat-card>
              <!-- -----------------Préstataire---------------------- -->
              <mat-card class="cardSituationPro">
                <mat-card-content>
                  <mat-form-field
                    appearance="outline"
                    *ngIf="show"
                    class="width33 marginRight10"
                  >
                    <mat-label>Statut</mat-label>
                    <mat-label>Statut</mat-label>
                    <mat-select
                      [disabled]="disabled"
                      name="Perso_Statut"
                      [(ngModel)]="data.Perso_Statut"
                      placeholder="Statut"
                    >
                      <mat-option
                        *ngFor="let statut of statuts"
                        [value]="statut.DiverSys_Index"
                      >
                        {{ statut.DiverSys_Titre }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="width33 marginRight10"
                  >
                    <mat-label>position</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Perso_Position"
                      type="number"
                      [(ngModel)]="data.Perso_Position"
                      placeholder="position"
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="width33">
                    <mat-label>Coefficient</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Perso_Coef"
                      type="number"
                      [(ngModel)]="data.Perso_Coef"
                      placeholder="Coefficient"
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    *ngIf="show"
                    class="width-120px marginRight10"
                  >
                    <mat-label>Date debut</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Perso_DateEntree"
                      [(ngModel)]="data.Perso_DateEntree"
                      [matDatepicker]="DateDebut"
                      placeholder="Date debut"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="DateDebut"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #DateDebut></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    *ngIf="show && showDateFinContrat"
                    class="width-120px"
                  >
                    <mat-label>Date fin</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Perso_DateSortie"
                      [(ngModel)]="data.Perso_DateSortie"
                      [matDatepicker]="DateFinContrat"
                      placeholder="Date fin"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="DateFinContrat"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #DateFinContrat></mat-datepicker>
                  </mat-form-field>
                  <br />
                  <mat-form-field
                    appearance="outline"
                    *ngIf="show"
                    class="width33 marginRight10"
                  >
                    <mat-label>Duree essai</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      type="number"
                      name="Perso_Duree"
                      [(ngModel)]="data.Perso_Duree"
                      placeholder="Duree essai"
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    *ngIf="show"
                    class="width33"
                  >
                    <mat-select
                      [disabled]="disabled"
                      name="Perso_DureeUnite"
                      [(ngModel)]="data.Perso_DureeUnite"
                      placeholder=""
                    >
                      <mat-option
                        *ngFor="let u of uniteDurer"
                        [value]="u.DiverSys_Index"
                        >{{ u.DiverSys_Titre }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <br />
                  <mat-form-field
                    appearance="outline"
                    *ngIf="show"
                    class="width33 marginRight10"
                  >
                    <mat-label>Volume</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      type="number"
                      name="Perso_Volume"
                      [(ngModel)]="data.Perso_Volume"
                      placeholder="Volume"
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    *ngIf="show"
                    class="width33"
                  >
                    <mat-select
                      [disabled]="disabled"
                      name="Perso_VolumeUnite"
                      [(ngModel)]="data.Perso_VolumeUnite"
                      placeholder=""
                    >
                      <mat-option
                        *ngFor="let u of uniteDurer"
                        [value]="u.DiverSys_Index"
                        >{{ u.DiverSys_Titre }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>
              <mat-card
                *ngIf="showPrestataire && show"
                class="cardSituationPro"
              >
                <mat-card-header class="heightTitre">
                  <mat-card-title>Préstataire</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Nom Société</mat-label>
                    <input
                      [disabled]="disabled"
                      matInput
                      name="Perso_A2"
                      [(ngModel)]="data.Perso_A2"
                      placeholder="Nom Société"
                    />
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Adresse facturation</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Perso_A4"
                      [(ngModel)]="data.Perso_A4"
                      placeholder="Adresse facturation"
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="width50 marginRight10"
                  >
                    <mat-label>Siret</mat-label>
                    <input
                      matInput
                      type="number"
                      [disabled]="disabled"
                      name="Perso_A3"
                      #Tiers_Siret="ngModel"
                      [(ngModel)]="data.Perso_A3"
                      placeholder="Siret"
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="width50">
                    <mat-label>Code TVA</mat-label>
                    <input
                      matInput
                      type="number"
                      [disabled]="disabled"
                      name="Perso_A5"
                      [(ngModel)]="data.Perso_A5"
                      placeholder="Code TVA"
                    />
                  </mat-form-field>
                </mat-card-content>
              </mat-card>
            </div>
          </form>
        </mat-tab>
        <!-------------------- Echanges ------------>
        <!-- <mat-tab *ngIf="perso_Type == '0' || perso_Type == '2'"  [disabled]="disabledEchanges" label="Échanges">
              <angular-editor  [config]="editorConfig" placeholder=" "  [(ngModel)]="data.Perso_A1"></angular-editor>
          </mat-tab> -->
        <!-- ------------Échanges candidat---------------------- -->
        <mat-tab
          *ngIf="perso_Type == '1' || perso_Type == '0'"
          [disabled]="disabledEchanges"
          label="Échanges"
        >
          <div>
            <!-- <app-avt-listes #listeEchangesComponen [showFilter]="false" [heightTable]="'400'" [dataSourceBrut]="datasourceEchanges" [displayedColumnsBrut]="columnsEchanges" [listBtn]="listBtnEchanges" (btnTable)="clickBtnHeat($event)"></app-avt-listes> -->
            <app-avt-liste-echange
              [disabled]="disabled"
              [code]="param_code"
              [type]="'collaborateur'"
            >
            </app-avt-liste-echange>
          </div>
        </mat-tab>
        <!-- -------------------------------------Alertes--------------------------------- -->
        <mat-tab *ngIf="perso_Type == '1' || perso_Type == '0'" label="Alertes">
          <div>
            <app-avt-liste-alert
              [disabled]="disabled"
              [code]="param_code"
              [type]="'collaborateur'"
            >
            </app-avt-liste-alert>
          </div>
        </mat-tab>
        <!-------------------- Matériels ------------>
        <mat-tab
          *ngIf="perso_Type == '0'"
          [disabled]="disabledMatetiels"
          label="Matériels"
        >
          <div class="margin-materiel">
            <mat-card>
              <h4>Note</h4>
              <!-- Angular Editor Supprimer -->
              <!-- <angular-editor  [config]="editorConfig" placeholder=" "   [(ngModel)]="data.Perso_Materiel"></angular-editor> -->
            </mat-card>
          </div>
          <div class="displayFlex margin-materiel">
            <mat-card style="width: calc(50% - 50px)">
              <h4>Liste matériels accordés</h4>
              <app-avt-listes
                #listeMachineComponen
                [showFilter]="true"
                [heightTable]="'400'"
                [displayedColumnsBrut]="columnMachine"
                [listBtn]="listBtnMachine"
                (btnTable)="clickBtnHeat($event)"
              >
              </app-avt-listes>
            </mat-card>
            <mat-card style="width: calc(50% - 50px)">
              <h4>Liste matériels réserver</h4>
              <app-avt-listes
                #listeReservationMachineComponen
                [showFilter]="true"
                [heightTable]="'400'"
                [displayedColumnsBrut]="columnMachine"
                [listBtn]="listBtnReservationMachine"
                (btnTable)="clickBtnHeat($event)"
              ></app-avt-listes>
            </mat-card>
          </div>
        </mat-tab>
        <!-------------------- document ------------>
        <mat-tab [disabled]="activerDocument" [label]="document">
          <div *ngIf="showDoc">
            <app-show-tree-doc
              [param_code]="data.Perso_Matricule"
              [File_Type]="'collaborateur'"
              [typeTrs]="typeTrs"
            >
            </app-show-tree-doc>
          </div>
        </mat-tab>
        <mat-tab *ngIf="showCompte" [disabled]="activerDocument" label="Compte">
          <mat-card class="example-card">
            <mat-card-content>
              <form class="example-form" #f="ngForm">
                <div class="btn">
                  <div class="button-row">
                    <button
                      (click)="ajouterCompte(f)"
                      [disabled]="disabledBtnCpmpte"
                      mat-raised-button
                      class="colorGreen"
                    >
                      <mat-icon>{{ btn.icon }}</mat-icon
                      >{{ btn.text }}
                    </button>
                  </div>
                </div>

                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>Nom d'utilisateur</mat-label>
                  <input
                    matInput
                    name="username"
                    #username="ngModel"
                    [(ngModel)]="user.username"
                    placeholder="Identifiant"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>Email</mat-label>
                  <input
                    matInput
                    type="email"
                    pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    name="email"
                    #email=""
                    [(ngModel)]="user.email"
                    placeholder="Email"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>Mot de passe</mat-label>
                  <input
                    matInput
                    type="password"
                    name="passwordd"
                    #passwordd="ngModel"
                    [(ngModel)]="user.password"
                    placeholder="Mot de passe"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>Confirmer</mat-label>
                  <input
                    type="password"
                    matInput
                    name="confirmpasswordd"
                    #confirmpasswordd="ngModel"
                    [(ngModel)]="user.confirmpassword"
                    placeholder="Confirmer"
                  />
                </mat-form-field>
              </form>
            </mat-card-content>
          </mat-card>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>
<!-- <input type="file" id="reaPDF">  -->
<!-- <input type="button" (click)="go()" value="go"> -->
<!-- <iframe  id="aaaa" src="" width="500px" height="1000px"></iframe> 
<embed id="aaaa" src="" width="600" height="500" alt="pdf" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" internalinstanceid="5"> -->
